import type { ComponentProps } from 'react';
import { forwardRef, useState } from 'react';
import type { InputProps } from '@chakra-ui/react';
import {
  CloseButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
} from '@chakra-ui/react';

import { CustomIcon } from '../../icon';

type Props = {
  onClear?: () => void;
  clearable?: boolean;
  label?: string;
} & InputProps;

const CustomInput = (
  { value, onClick, onChange, onClear, clearable, label }: Props,
  ref: ComponentProps<typeof Input>['ref'],
) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <>
      {label && <Text variant='heading6'>{label}</Text>}
      <InputGroup>
        <InputLeftElement pointerEvents='none'>
          <CustomIcon name='calendar' color={isFocused ? 'primary500' : 'neutral500'} />
        </InputLeftElement>
        <Input
          autoComplete='off'
          background='white'
          value={value}
          ref={ref}
          onClick={onClick}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          borderColor='neutral200'
          focusBorderColor='primary400'
          _hover={{
            borderColor: 'neutral400',
          }}
          paddingRight={8}
        />
        {clearable && (
          <InputRightElement width={8}>
            <CloseButton size='sm' onClick={onClear} />
          </InputRightElement>
        )}
      </InputGroup>
    </>
  );
};

export const DatePickerInput = forwardRef(CustomInput);
